<div class="form-field">
  <div *ngIf="label" class="form-field__label">
    <label>{{ label }}</label>
    <span *ngIf="required && label" class="form-field__label__required"> *</span>
    <div *ngIf="subLabel" class="form-field__sub-label">{{ subLabel }}</div>
  </div>

  <div
    [ngClass]="{
      'form-field__control--invalid': invalid && control.touched,
      'form-field__control--valid': valid && control.touched && required
    }"
    class="form-field__control"
  >
    <ng-content></ng-content>
  </div>

  <div *ngIf="invalid && control.touched && errorMessage" class="form-field__error-message">
    {{ errorMessage }}
  </div>
</div>
